define(
    'viewmodels/secured/explorer/navigation/libraries/accessFolder',[
        "durandal/app",
        "viewmodels/ViewModel",
        "providers/dataprovider",
        "i19n!i19n/strings",
    ],
    function (app, ViewModel, dataProvider, i19n) {
        var vm = new ViewModel(
        {
            id: '',
            i19n: i19n,

            access: ko.observableArray([]),
            
            accessData: {
                id: 'explorer-folder',
                //h: 150,                
                i19n: i19n,

                initialize: ko.observable(),
                refresh: ko.observable(),
                save: ko.observable(),
                cancel: ko.observable(),

                edit: ko.observable(),
                isEdit: ko.observable(false),

                dataSource: {
                    rightsColumn: [],
                    teamSelect: [],
                    personSelect: [],
                    teamGrid: [],
                    personGrid: []
                }
            },

            isInherited: ko.observable(false)
        });

        vm.activate = function () {
        };
        vm.attached = function () {
        };
        vm.loadAccess = function (id) {
            var d = $.Deferred();
            var self = this;

            vm.id = id;

            loadData(id)
            .done(function (access) {

                self.accessData.edit()(true);
                self.accessData.initialize()();
                self.accessData.refresh()();

                d.resolve();
            })
            .fail(function (e) {
                e.stopPropagation = true;

                d.reject(e);
            });

            return d.promise();
        }
        vm.inherit = function () {
            var d = $.Deferred();

            var self = this;

            var data = {
                folderId: self.id,
                teams: [],
                persons: []
            };

            dataProvider
            .accesscontrolfolder
            .updateAccessControl(data)
            .done(function (result) {
                loadData(self.id)
                .done(function (result) {
                    dataProvider
                    .accesscontrolfolder
                    .inherit(self.id)
                    .done(function (result) {
                        loadData(self.id)
                        .done(function (result) {
                            //self.accessData.refresh()();
                            d.resolve();
                        })
                        .fail(function (e) {
                            d.reject(e);
                        });
                    })
                    .fail(function (e) {
                        d.reject(e);
                    });
                })
                .fail(function (e) {
                    d.reject(e);
                });
            })
            .fail(function (e) {
                d.reject(e);
            });

            return d.promise();
        };
        
        vm.saveClick = function () {
            var d = $.Deferred();

            var self = this;

            self.accessData.save()(function (data) {
                data = {
                    folderId: self.id,
                    teams: mapTeamWeb(data.teams),
                    persons: mapPersonWeb(data.persons)
                };

                dataProvider.accesscontrolfolder
                .updateAccessControl(data)
                .done(function (result) {
                    loadData(self.id)
                        .done(function (result) {
                            self.accessData.refresh()();

                            d.resolve();
                        })
                        .fail(function (e) {
                            d.reject(e);
                        });
                })
                .fail(function (e) {
                    d.reject(e);
                });
            });

            return d.promise();
        };
        vm.cancelClick = function () {
            loadData(vm.id)
            .done(function (result) {
                vm.accessData.refresh()();
            })
            .fail(function (e) {
            });
        };

        vm.selectable = function (b) {
            vm.accessData.selectable(b);
        };

        return vm;

        function loadData(id) {
            var d = $.Deferred();

            dataProvider
            .accesscontrolfolder
            .getAccessControl(id)
            .done(function (data) {
                vm.access(data);
                    
                vm.isInherited(data.isInherited == null ? false : data.isInherited);

                vm.accessData.dataSource.rightsColumn = mapRightsColumn(vm.access().accessControlRoles);

                vm.accessData.dataSource.teamSelect = mapTeamSelect(vm.access().availableTeams);
                vm.accessData.dataSource.personSelect = mapPersonSelect(vm.access().availablePersons);

                vm.accessData.dataSource.teamGrid = mapTeamGrid(vm.access().accessControlTeams);
                vm.accessData.dataSource.personGrid = mapPersonGrid(vm.access().accessControlPersons);

                d.resolve();
            })
            .fail(function (e) {
                e.stopPropagation = true;

                d.reject('error loading access control');

                console.error(e);
            });

            return d.promise();
        }

        function mapRightsColumn(data) {
            data = _.filter(data, function (itm) { return itm.isItemVisible || true; });
            data = _.map(data, function (itm) { return { value: itm.id, name: itm.name, field: "__r" + itm.id, hideButtonOnGuest: (itm.id == 20 || itm.id == 30 ? false : true) }; });

            return data;
        }

        function mapTeamSelect(data) {
            data = _.map(data, function (itm) { return { id: itm.teamId, name: itm.displayName, rights: itm.roleId, isGuest: itm.isGuest }; });
            data = _.sortBy(data, function (itm) { return itm.name ? itm.name.toUpperCase() : '' });

            return data;
        }
        function mapPersonSelect(data) {
            data = _.map(data, function (itm) { return { id: itm.personId, name: itm.displayName, rights: itm.roleId, isGuest: itm.isGuest, personType: itm.personType }; });
            data = _.sortBy(data, function (itm) { return itm.name ? itm.name.toUpperCase() : '' });

            return data;
        }

        function mapTeamGrid(data) {
            data = _.map(data, function (itm) { return { id: itm.teamId, name: itm.displayName, rights: itm.roleId, isGuest: itm.isGuest }; });
            data = _.sortBy(data, function (itm) { return itm.name ? itm.name.toUpperCase() : '' });

            return data;
        }
        function mapPersonGrid(data) {
            data = _.map(data, function (itm) { return { id: itm.personId, name: itm.displayName, rights: itm.roleId, isGuest: itm.isGuest, personType: itm.personType }; });
            data = _.sortBy(data, function (itm) { return itm.name ? itm.name.toUpperCase() : '' });

            return data;
        }

        function mapTeamWeb(data) {
            var o = _.map(data, function (itm) {
                return { teamId: itm.id, isGuest: itm.isGuest, roleId: itm.rights };
            });

            return o;

            //var n = _.filter(vm.access().availableTeams, function (itm) { return _.contains(teams, itm.teamId); });
            //var o = _.map(vm.access().accessControlTeams.concat(n), function (itm) {
            //    return { teamId: itm.teamId, isGuest: itm.isGuest, roleId: itm.roleId == null ? 0 : itm.roleId };
            //});            

            //var data = {
            //    libraryId: vm.id,
            //    teams: o,
            //    persons: vm.access().accessControlPersons
            //};

            //dataProvider
            //    .accesscontrollibrary
            //    .addTeamAccessInLibrary(data)
            //    .done(function (result) {
            //        loadAccess()
            //            .done(function (result) {                            
            //                vm.accessData.refresh();
            //            })
            //            .fail(function (e) { });
            //    })
            //    .fail(function (e) {
            //        console.log(e);
            //    });
        }
        function mapPersonWeb(data) {
            var o = _.map(data, function (itm) {
                return { personId: itm.id, isGuest: itm.isGuest, personType: itm.personType, roleId: itm.rights };
            });

            return o;

            //var n = _.filter(vm.access().availablePersons, function (itm) { return _.contains(persons, itm.personId); });
            //var o = _.map(vm.access().accessControlPersons.concat(n), function (itm) {
            //    return { personId: itm.personId, isGuest: itm.isGuest, personType: itm.personType, roleId: itm.roleId == null ? 0 : itm.roleId };
            //});

            //var data = {
            //    libraryId: vm.id,
            //    teams: vm.access().accessControlTeams,
            //    persons: o
            //};

            //dataProvider
            //    .accesscontrollibrary
            //    .addPersonAccessInLibrary(data)
            //    .done(function (result) {
            //        loadAccess()
            //            .done(function (result) {
            //                vm.accessData.refresh();
            //            })
            //            .fail(function (e) { });
            //    })
            //    .fail(function (e) {
            //        console.log(e);
            //    });
        }
    }
);
